<template>
	<v-tabs-items
		:value="value"
		:continuous="continuous"
		:mandatory="mandatory"
		:multiple="multiple"
		v-bind="$attrs"
		v-on="unhandled_events"
		@change="on_change"
	>
		<slot></slot>
	</v-tabs-items>
</template>

<script>
export default {
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: [String, Number],
		continuous: Boolean,
		mandatory: Boolean,
		multiple: Boolean
	},
	computed: {
		unhandled_events() {
			const { change, ...listeners } = this.$listeners;
			return listeners;
		}
	},
	methods: {
		on_change(value) {
			this.$emit('change', value);
		}
	}
};
</script>
